import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { useTranslation } from '@root/shared/localization'
import {
  ArrowDownRightIcon,
  ArrowRightIcon,
  ArrowUpRightIcon,
  ArrowsLeftRightIcon,
} from '@root/shared/ui-kit'

import { TRX_TYPE_COLOR_MAP, TRX_TYPE_LABEL_MAP } from '../constants'

import type { TransactionListItemVariant } from './transaction-list-item'
import type { Transaction } from '../../model'
import type { IconProps } from '@root/shared/ui-kit'

type TransactionListItemTypeProps = {
  transactionType: Transaction.Type
  variant: TransactionListItemVariant
}

export const TransactionListItemType: React.FC<
  TransactionListItemTypeProps
> = ({ transactionType, variant }) => {
  const { t } = useTranslation()
  const Icon = TRX_TYPE_ICON_MAP[transactionType]
  return (
    <Root data-type={transactionType} data-variant={variant}>
      <Icon size={14} />
      <Label>{t(TRX_TYPE_LABEL_MAP[transactionType])}</Label>
    </Root>
  )
}

const Root = styled.div`
  &[data-type='transfer'] {
    color: ${TRX_TYPE_COLOR_MAP.transfer};
  }
  &[data-type='buy'] {
    color: ${TRX_TYPE_COLOR_MAP.buy};
  }
  &[data-type='sell'] {
    color: ${TRX_TYPE_COLOR_MAP.sell};
  }
  &[data-type='swap'] {
    color: ${TRX_TYPE_COLOR_MAP.swap};
  }

  display: grid;
  place-items: center;
  place-content: center;
  grid-template-columns: auto auto;
  justify-content: start;
  gap: 4px;

  &[data-variant='square'] {
    gap: 2px;
  }
`

const TRX_TYPE_ICON_MAP: Record<Transaction.Type, React.FC<IconProps>> = {
  transfer: ArrowRightIcon,
  buy: ArrowUpRightIcon,
  sell: ArrowDownRightIcon,
  swap: ArrowsLeftRightIcon,
}

const Label = styled(Typography).attrs({
  variant: 'description-semi-bold',
  component: 'span',
})``
